import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BillOfQuantitiesPositionsLogicService } from './logic/bill-of-quantities-positions/bill-of-quantities-positions-logic.service';
import { BillOfQuantitiesPositionsDaoService } from './dao/bill-of-quantities-positions-dao.service';
import { BillOfQuantitiesPositionsService } from './logic/bill-of-quantities-positions.service';
import { BillOfQuantitiesDbDaoService } from './dao/bill-of-quantities-positions-dao/bill-of-quantities-positions-db-dao.service';
import { BillOfQuantitiesDbTableDefinition } from './dao/bill-of-quantities-positions-dao/bill-of-quantities-positions-db-table-definition';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    { provide: BillOfQuantitiesPositionsService, useClass: BillOfQuantitiesPositionsLogicService },
    {
      provide: BillOfQuantitiesPositionsDaoService,
      useClass: BillOfQuantitiesDbDaoService
    },
    { provide: BillOfQuantitiesDbTableDefinition },
  ]
})
export class BillOfQuantitiesPositionsModule {}
